import profileImage from "../statics/images/profile.jpg";
import "./ProfileImage.css";

export function ProfileImage() {
  return <img src={profileImage} className="profile-image" alt="profile" />;
}
